import React, { useEffect, useState } from 'react';
import styles from './UserStatTab.module.scss';

import DateNavigation from '../../../utils/DateNavigation/DateNavigation';

import { getSignupsByPeriod, getLastSignups, getGeographicStats } from '../../../utils/api/insightsAPI';

const debug = true;

const UserStatTab = () => {
  const [period, setPeriod] = useState('week');
  const [date, setDate] = useState(new Date());
  const [dateRange, setDateRange] = useState("");

  const [signups, setSignups] = useState({ currentPeriod: 0, previousPeriod: 0, variation: 0 });

  const [geoData, setGeoData] = useState([]);
  const [openCountries, setOpenCountries] = useState({});

  const [lastSignups, setLastSignups] = useState([]);
  const [offset, setOffset] = useState(0);
  const limit = 10;
  const [hasMore, setHasMore] = useState(true);


  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await getGeographicStats();
        setGeoData(data);
      } catch (error) {
        console.error("Erreur lors du chargement des données :", error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const signupsData = await getSignupsByPeriod(period, date);
        setSignups({ currentPeriod: signupsData.currentPeriod, previousPeriod: signupsData.previousPeriod, variation: signupsData.variation });
      } catch (error) {
        console.error("Erreur lors du chargement des données :", error);
      }
    };

    fetchData();
  }, [period, date.getTime()]);


  useEffect(() => {
    const fetchData = async () => {
      try {
        const lastSignupsData = await getLastSignups(offset, limit);
        setLastSignups(prev => offset === 0 ? lastSignupsData : [...prev, ...lastSignupsData]); // append
        if (lastSignupsData.length < limit) { setHasMore(false);  }
      } catch (error) {
        console.error("Erreur lors du chargement des données :", error);
      }
    };

    fetchData();
  }, [period, date.getTime(), offset]);


  const handleLoadMore = () => {
    setOffset(prev => prev + limit);
  };


  // Regrouper les utilisateurs par date pour le tableau
  const groupedByDate = lastSignups.reduce((acc, user) => {
    const date = new Date(user.created_at).toLocaleDateString('fr-FR');
    if (!acc[date]) acc[date] = [];
    acc[date].push(user);
    return acc;
  }, {});

  const toggleCountryDetails = (countryCode) => {
    setOpenCountries(prev => ({
      ...prev,
      [countryCode]: !prev[countryCode]
    }));
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <div className={styles.header}>
          <h2 className={styles.title}>Inscriptions</h2>
          <p>({dateRange})</p>
        </div>
      </div>

      <DateNavigation period={period} setPeriod={setPeriod} date={date} setDate={setDate} setDateRange={setDateRange} />

      <div className={styles.cards}>
        <div className={styles.card}>
          <p className={styles.label}>Nouveaux inscrits</p>
          <h3>{signups.currentPeriod.toLocaleString()}</h3>
          <p
            className={
              signups.variation > 0 ? styles.variationUp : styles.variationDown
            }
          >
            {signups.variation > 0
              ? '+'
              : signups.variation < 0
              ? '-'
              : ''}{' '}
            {Math.abs(signups.variation)}%
          </p>

          <p className={styles.label}>Dernières inscriptions</p>
        </div>

        <div className={styles.card}>
          <p className={styles.label}>Origines géographiques</p>
          
          {Object.entries(geoData).map(([country, data]) => (
            <div key={country} className={styles.geoBlock}>
              <div className={styles.geoHeader}>
                <strong>{country}</strong> {data.total} joueur{data.total > 1 ? 's' : ''}
                <button onClick={() => toggleCountryDetails(country)} className={styles.detailButton}>
                  {openCountries[country] ? 'Masquer' : 'Détails'}
                </button>
              </div>

              {openCountries[country] && (
                <ul className={styles.geoList}>
                  {data.codesPostaux.map((entry, i) => (
                    <li key={i}>
                      {entry.codePostal !== "" ? entry.codePostal : "inconnu"} — {entry.nb} joueur{entry.nb > 1 ? 's' : ''}
                    </li>
                  ))}
                </ul>
              )}
            </div>
          ))}
        </div>

        <div className={styles.card}>
          <p className={styles.label}>Dernières inscriptions</p>
          
          {Object.entries(groupedByDate).map(([date, users]) => (
            <div key={date}>
              <h4>{date}</h4>
              <div className={styles.tableWrapper}>
                <table className={styles.signupTable}>
                  <colgroup>
                    <col />
                    <col />
                    <col />
                    <col />
                    <col />
                  </colgroup>
                  <thead>
                    <tr>
                      <th>Pseudo</th>
                      <th>Email</th>
                      <th>CP</th>
                      <th>Pays</th>
                      <th>Heure</th>
                    </tr>
                  </thead>
                  <tbody>
                    {users.map((u, idx) => (
                      <tr key={idx}>
                        <td>{u.pseudo}</td>
                        <td>{u.email}</td>
                        <td>{u.codePostal}</td>
                        <td>{u.country}</td>
                        <td>{new Date(u.created_at).toLocaleTimeString('fr-FR')}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                </div>
            </div>
          ))}

          <p>
            { hasMore ? (
              <button onClick={handleLoadMore}>Charger plus</button>
            ) : (
              <span>Il n'y a plus de données à charger.</span>
            )}
            
          </p>
        </div>
      </div>
    </div>
  );
};

export default UserStatTab;
